import { gql } from '@apollo/client';

export const GET_COLUMNS_LIST = gql`
  query GetColumnsList($params: FindColumnListInput!) {
    columns(params: $params) {
      success
      message
      errors
      data {
        columns {
          id
          tableId
          columnName
          dataType
          description
          businessRules
          exampleValues
          isNullable
          isPrimaryKey
          isForeignKey
          foreignKeyReference
          keywords
          isCore
          alwaysInclude
          allowedValues
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_COLUMN = gql`
  query GetColumn($params: FindColumnInput!) {
    column(params: $params) {
      success
      message
      errors
      data {
        id
        tableId
        columnName
        dataType
        description
        businessRules
        exampleValues
        isNullable
        isPrimaryKey
        isForeignKey
        foreignKeyReference
        keywords
        isCore
        alwaysInclude
        allowedValues
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
